<mat-card [ngClass]="class">
  <mat-card-content>
    <div class="header-row">
      <!-- First column for the logo -->
      <div class="flip-logo">
        <app-flip-logo></app-flip-logo>
      </div>
      <!-- Second column for text -->
      <div class="text-column">
        <div class="lock-text-row">
          <mat-icon class="lock">lock</mat-icon>
          {{ assessmentStatus }}
        </div>
        <div class="date-text-row">
          {{ lastAssessmentDetails }}
        </div>
      </div>
    </div>
    <div class="collapsible">
      <app-collapsible [items]="items"></app-collapsible>
    </div>
  </mat-card-content>
</mat-card>
